import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router'
import { toast } from 'react-toastify'
import { ApplicationRoutes } from '~/hooks/useRouting'
import { LoginBackground } from '~/pages/Login/LoginBackground'
import { LoginPrompt } from '~/pages/Login/LoginPrompt'
import { PbxPrompt } from '~/pages/Login/PbxPrompt'

export const LoginPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const passwordReset = searchParams.get('passwordReset')
    if (passwordReset === '1') {
      toast.success(
        t('login.passwordResetSuccess', 'Password updated — please sign in'),
      )
      const next = new URLSearchParams(searchParams)
      next.delete('passwordReset')
      setSearchParams(next, { replace: true })
    }
  }, [searchParams, setSearchParams, t])

  const handleLoginSuccess = () => {
    const returnUrl = searchParams.get('returnUrl')
    const selectPbxUrl = returnUrl
      ? `${ApplicationRoutes.SELECT_PBX}?returnUrl=${encodeURIComponent(returnUrl)}`
      : ApplicationRoutes.SELECT_PBX
    navigate(selectPbxUrl)
  }

  return (
    <LoginBackground>
      <LoginPrompt onLoginSuccess={handleLoginSuccess} />
    </LoginBackground>
  )
}

export const SelectPbxPage = () => {
  const navigate = useNavigate()

  const handleBackButtonPressed = () => {
    navigate(ApplicationRoutes.LOGIN, {
      replace: true,
    })
  }

  return (
    <LoginBackground>
      <PbxPrompt onBackButtonPressed={handleBackButtonPressed} />
    </LoginBackground>
  )
}

export default LoginPage
